import { BottomSheet, BottomSheetLoadingContent } from "@clipboard-health/ui-components";
import { type UseModalState } from "@clipboard-health/ui-components";
import { getSafeAreaPaddings } from "@clipboard-health/ui-theme";
import { DialogContent } from "@mui/material";
import { useCallback } from "react";

import { BottomSheetHeader } from "../../../../components/BottomSheetHeader";

interface PandaDocEmbeddedSessionLoadingBottomSheetProps {
  modalState: UseModalState;
}

export function PandaDocEmbeddedSessionLoadingBottomSheet(
  props: PandaDocEmbeddedSessionLoadingBottomSheetProps
) {
  const { modalState } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
      paperSx={{
        height: "60%",
        ...getSafeAreaPaddings({ bottom: true }),
      }}
    >
      <DialogContent sx={{ paddingX: 5 }}>
        <BottomSheetLoadingContent
          title="Loading Document to Sign"
          description="This usually takes a few seconds. Please don't close the app."
        />
      </DialogContent>
    </BottomSheet>
  );
}
